    newRender = async () => {
        const bodyElement = document.querySelector(".salepify-fg-advanced-body");
        bodyElement.innerHTML = '<div class="loader"></div>'
        let bodyHtml = "";
        const listRuleNeedToAddGift = [];
        const listRuleNeedToRemoveGift = [];

        let availableToClaim = [];
        let needToReload = false
        let hasRuleMetCondition = false;
        for (let i = 0; i < window.tlAdvancedFreeGift.rules.length; i++) {
            const rule = window.tlAdvancedFreeGift.rules[i];
            const ruleId = rule.id;
            const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = window.tlAdvancedFreeGift.getRemain(rule);
            if(claimedCount < canClaimCount) {
                rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
            }else if(claimedCount > canClaimCount){
                rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                    id: ruleId,
                    removeTime: claimedCount - canClaimCount
                }): null;
            }
            
            // Store handle of parent and child product
            const uniqueProductHandle = new Set();
            
            // Store list parent id in order current product => required => rest product 
            const listChildDisplayIds = [];
            // ChildId map quantity required
            const childMapRequiredQty = {}
            rule.listChilds.map(child =>{
                listChildDisplayIds.push(child.shopify_id);
                if(!window.tlAdvancedFreeGift.shopifyIdMapData.get(child.product_id)){
                    uniqueProductHandle.add(child.handle)
                }
                if(child.quantity){
                    childMapRequiredQty[child.shopify_id] = child.quantity;
                }
            })

            // ParentId map quantity required
            const parentMapRequiredQty = {};

            const requireParents = []
            const highPriorityParents = [];
            const lowPriorityParents = [];
            const productIdKey = rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT ? "shopify_id" : "product_id";

            if(
                (rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT) ||
                (rule.apply_to_product === window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.VARIANT)
            ){
                rule.listParents.map(parent =>{
                    const productId = parent[productIdKey];
                    if(!window.tlAdvancedFreeGift.shopifyIdMapData.get(productId)){
                        uniqueProductHandle.add(parent.handle);
                    }

                    if(productId == window.tlAdvancedFreeGift.currentProductId){
                        parent.quantity ? requireParents.unshift(parent.shopify_id) : highPriorityParents.unshift(parent.shopify_id);
                    }else {
                        parent.quantity ? requireParents.push(parent.shopify_id) : lowPriorityParents.push(parent.shopify_id);
                    }
                    parentMapRequiredQty[parent.shopify_id] = parent.quantity;
                })
            }

            const listParentDisplayIds = [...requireParents, ...highPriorityParents, ...lowPriorityParents];
            await window.tlAdvancedFreeGift.updateProductData(Array.from(uniqueProductHandle));
            if(rule.show_free_gift_widget && window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)){

                if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                    hasRuleMetCondition = true;
                }
                const totalGift = rule.gift_qty * window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
                const translation = window.tlAdvancedFreeGift.getRuleTranslation(ruleId)
                const gifts = await  window.tlAdvancedFreeGift.getGifts(rule, listChildDisplayIds, childMapRequiredQty);
                bodyHtml += `
                    <div id="salepify-fg-advanced-main-section-${ruleId}"  
                        class="salepify-fg-advanced-main-section block--flex 
                        ${i == 0 ? " salepify-fg-advanced-main-section--view-more" : " salepify-fg-advanced-main-section--view-less"}
                        ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET ? " salepify-fg-advanced-main-section--allow-claim" : ""}
                        ${conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ? " salepify-fg-advanced-main-section--claimed" : ""}" 
                    >
                        <div class="block--flex-inline flex--space-between">
                            <div class= "salepify-fg-advanced-main-section__offer-title text--bold">
                                ${conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET ? 
                                    window.tlAdvancedFreeGift.handleReplaceVariable(rule, window.tlAdvancedFreeGift.getOfferTitle(rule), remain, remainSpecific, totalGift) : 
                                    translation.main_offer.eligible_offer_title
                                }
                            </div>
                            
                            <div 
                                class="salepify-fg-advanced-main-section__view-offer-btn btn--plain" 
                                onclick='window.tlAdvancedFreeGift.handleViewMore("${ruleId}")'
                            >
                                ${i == 0 ? translation.main_offer.view_less : translation.main_offer.view_more}
                            </div>
                        </div>
                        
                        <div class="salepify-fg-advanced-offer block--flex-inline">
                            ${window.tlAdvancedFreeGift.renderOffer(listParentDisplayIds)}
                        </div>

                        <div class="divider"></div>
                        
                        <div class="salepify-fg-advanced-customer-buy block--flex block--collapsible">
                            ${window.tlAdvancedFreeGift.renderCustomerBuy(listParentDisplayIds, parentMapRequiredQty)}
                        </div>

                        <div class="salepify-fg-advanced-main-section__upsell-banner">
                            ${window.tlAdvancedFreeGift.handleReplaceVariable(
                                rule, 
                                window.tlAdvancedFreeGift.renderUpsellMsg(conditionState, rule), 
                                remain, 
                                remainSpecific, 
                                totalGift
                            )}
                        </div>

                        <div class="salepify-fg-advanced-gift-list block--flex block--collapsible">
                            ${window.tlAdvancedFreeGift.renderGifts(
                               rule,
                               gifts,
                              conditionState,
                          )}

                        </div>
                      
                        <div class="salepify-fg-advanced-footer block--flex-inline flex--space-between block--collapsible"
                            style="display: ${(conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET && !rule.auto_add_gift) ? "flex" : "none"}"
                        >
                            <div class="salepify-fg-advanced-footer__remain-gift-title">
                                ${translation.manual_choose_gift.selected_text} 
                                ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                    window.tlAdvancedFreeGift.getTotalSelectedGift(ruleId) : totalGift
                                }/${totalGift}
                            </div>
                            ${
                                conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                    `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})'>
                                        ${translation.manual_choose_gift.claim_btn}
                                    </div>` :
                                    `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                        ${translation.manual_choose_gift.claimed_btn}
                                    </div> `
                            }
                        </div>
                        <div id="salepify-fg-advanced-error-${ruleId}">
                            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                            </svg>
                            <span class="salepify-fg-advanced-error__message"></span>
                        </div>
                    </div>
                `;

                if(conditionState == window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim.push(ruleId);
            }else {
                needToReload = window.tlAdvancedFreeGift.updateSelectedGifts(rule)
            }
        }

        if(listRuleNeedToAddGift.length){
            if(window.tlAdvancedFreeGift.itemsInTempCart.size){
                listRuleNeedToAddGift.map((ruleId) => {
                    window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
                })
            }else {
                const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
                if(addCartReq.status === 200){
                    if (window.tlAdvancedFreeGift.displaySettings?.show_confetti_animation) {
                        window.tlAdvancedFreeGift.showConfetti();
                    }
                    window.tlAdvancedFreeGift.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim.length)
                    if(needToReload) {
                        if(!window.TLCustomEventGiftsAdvanced){
                            window.location.reload();
                        } else if (window.TLCustomEventGiftsAdvanced == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToReload"));
                        }
                    };
                }else {
                    // Return error if there are not enough gift to add
                    const addCartRes = await addCartReq.json();
                    window.tlAdvancedFreeGift.showIconPopUpMessage(addCartRes.description, 1)
                }
            }
        }else {
            if(availableToClaim.length){
                const manualText = window.tlAdvancedFreeGift.getRuleTranslation(availableToClaim[0]).gift_icon.manual
                window.tlAdvancedFreeGift.showIconPopUpMessage(manualText, availableToClaim.length);
            }else {
                window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
            }
        }
        if(bodyHtml) {
            const popupIcon = document.querySelector(".salepify-fg-advanced-icon-popup__icon");
            
            popupIcon.style.display = window.tlAdvancedFreeGift.displaySettings.icon_popup.is_icon_displayed ? "block" : "none";
            window.tlAdvancedFreeGift.iconPopupElement.style.display = "flex";
            window.tlAdvancedFreeGift.iconPopupElement.style.backgroundImage = window.tlAdvancedFreeGift.displaySettings.icon_popup.is_icon_displayed ? "none" : `url(${window.tlAdvancedFreeGift.displaySettings.icon_popup.adv_free_gift_image.url})`;
      
            bodyElement.innerHTML = bodyHtml;

            if(hasRuleMetCondition){
                if (window.tlAdvancedFreeGift.displaySettings?.show_confetti_animation) {
                    window.tlAdvancedFreeGift.showConfetti();
                }
               
                //window.tlAdvancedFreeGift.openGiftModal();
            }
        }
        
        if(listRuleNeedToRemoveGift.length && !window.tlAdvancedFreeGift.itemsInTempCart.size){
            await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);
            if(!window.TLCustomEventGiftsAdvanced){
                window.location.reload();
            } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
            }
        }
    }

    newReRender = async () => {
        const listRuleNeedToAddGift = [];
        const listRuleNeedToRemoveGift = [];

        let availableToClaim = [];
        let needToReload = false;
        let hasRuleMetCondition = false;
        for (let i = 0; i < window.tlAdvancedFreeGift.rules.length; i++) { 
            const rule = window.tlAdvancedFreeGift.rules[i];
            const ruleId = rule.id;
            const [conditionState, claimedCount, canClaimCount, remain, remainSpecific] = window.tlAdvancedFreeGift.getRemain(rule);
            if(claimedCount < canClaimCount) {
                rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
                
            }else if(claimedCount > canClaimCount){
                rule.auto_remove_gift ? listRuleNeedToRemoveGift.push({
                    id: ruleId,
                    removeTime: claimedCount - canClaimCount
                }): null;
            }
            if(rule.show_free_gift_widget && window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)){
                if(claimedCount < canClaimCount && !rule.auto_add_gift) {
                    hasRuleMetCondition = true;
                }
            
              
                const totalGift = rule.gift_qty * window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
                const mainSectionElement = document.querySelector(`#salepify-fg-advanced-main-section-${ruleId}`);
                const translation = window.tlAdvancedFreeGift.getRuleTranslation(ruleId)
                // Offer title
                let offerTitleInnerHTML = translation.main_offer.eligible_offer_title;

                if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                    // Set state main section
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim", "salepify-fg-advanced-main-section--claimed");                
                    offerTitleInnerHTML = window.tlAdvancedFreeGift.handleReplaceVariable(rule, window.tlAdvancedFreeGift.getOfferTitle(rule), remain, remainSpecific, totalGift);
                }else if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM){
                    // Set state main section
                   
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--claimed");
                    mainSectionElement.classList.add("salepify-fg-advanced-main-section--allow-claim")
                }else {
                    // Set state main section
                
                    
                    mainSectionElement.classList.remove("salepify-fg-advanced-main-section--allow-claim");
                    mainSectionElement.classList.add("salepify-fg-advanced-main-section--claimed")
                }

                // Set innerHTML of offer_title
                mainSectionElement.querySelector(".salepify-fg-advanced-main-section__offer-title").innerHTML = offerTitleInnerHTML;

                // Set innerHTML of upsell_msg
                mainSectionElement.querySelector(".salepify-fg-advanced-main-section__upsell-banner").innerHTML = window.tlAdvancedFreeGift.handleReplaceVariable(
                    rule, 
                    window.tlAdvancedFreeGift.renderUpsellMsg(conditionState, rule), 
                    remain, 
                    remainSpecific, 
                    totalGift
                );

                // Footer elment
                const footerElment = mainSectionElement.querySelector(".salepify-fg-advanced-footer");
                if(!rule.auto_add_gift && conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                    //Set footer style
                    footerElment.innerHTML = `
                        <div class="salepify-fg-advanced-footer__remain-gift-title">
                            ${translation.manual_choose_gift.selected_text} 
                            ${conditionState !== window.tlAdvancedFreeGift.CONDITION_STATE.MET_AFFTER_CLAIM ?
                                window.tlAdvancedFreeGift.getTotalSelectedGift(ruleId) : totalGift
                            }/${totalGift}
                        </div>
                            
                        ${
                            conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM ? 
                                `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" 
                                    onclick='${window.tlAdvancedFreeGift.itemsInTempCart.size > 0 ? 
                                        `window.tlAdvancedFreeGift.handleAddGiftToTempCart(${ruleId})`  :
                                        `window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})` 
                                    }'
                                >
                                    ${translation.manual_choose_gift.claim_btn}
                                </div>` :
                                `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                    ${translation.manual_choose_gift.claimed_btn}
                                </div> `
                        }
                    `;
                    footerElment.style.display = "flex";
                }else {
                    footerElment.style.display = "none";
                }

                const listGiftElement = mainSectionElement.querySelectorAll(`div[id^="salepify-fg-advanced-gift-${ruleId}"]`);

                listGiftElement.forEach((element) => {
                    const checkBoxElement = element.querySelector(".salepify-fg-advanced-checkbox");
                    const imageElement = element.querySelector(".salepify-fg-advanced-gift-info__img");

                    if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM){
                        if(!rule.auto_add_gift){
                            //Set show checkbox
                            checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--hide");
                            checkBoxElement.classList.add("salepify-fg-advanced-checkbox--show");
                        }

                        // Set image
                        imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                        imageElement.querySelector("svg").style.display = "none";
                    
                    }else {
                        //Set hide checkbox
                        checkBoxElement.classList.remove("salepify-fg-advanced-checkbox--show");
                        checkBoxElement.classList.add("salepify-fg-advanced-checkbox--hide");
                        element.querySelector(".salepify-fg-advanced-gift-qty-selector").style.display = "none";

                        // Set image
                        if(conditionState === window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET){
                            imageElement.classList.add("salepify-fg-advanced-gift-info__img--condition-not-met");
                            imageElement.querySelector("svg").style.display = "block";
                            checkBoxElement.querySelector(".salepify-fg-advanced-checkbox__inp-cbx").checked = false;
    
                            if(!rule.auto_add_gift){
                                window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, {}); 
                            }
                        }else {
                            imageElement.classList.remove("salepify-fg-advanced-gift-info__img--condition-not-met");
                            imageElement.querySelector("svg").style.display = "none";
                        }
                    }
                })

                if(conditionState == window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM) availableToClaim.push(ruleId);
                // Update gift selected with same buy option
                if(rule.gift_type == window.tlAdvancedFreeGift.GIFT_TYPE.SAME_BUY){ 
                    window.tlAdvancedFreeGift.updateSelectedGiftWithSameBuyOpt(rule);
                }
            }else {
                needToReload = window.tlAdvancedFreeGift.updateSelectedGifts(rule);
            }
        }

        if(listRuleNeedToAddGift.length){
            if(window.tlAdvancedFreeGift.itemsInTempCart.size){
                listRuleNeedToAddGift.map((ruleId) => {
                    window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
                })
            }else {
                const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(listRuleNeedToAddGift);
                if(addCartReq.status === 200){
                    if (window.tlAdvancedFreeGift.displaySettings?.show_confetti_animation) {
                        window.tlAdvancedFreeGift.showConfetti();
                    }
                    window.tlAdvancedFreeGift.showIconPopUpMessage("You’ve received a gift. Please reload to view the changes.", availableToClaim.length);
                    if(needToReload) {
                        if(!window.TLCustomEventGiftsAdvanced){
                            window.location.reload();
                        } else if (window.TLCustomEventGiftsAdvanced == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-reRender-needToReload"));
                        }
                    };
                }else {
                    // Return error if there are not enough gift to add
                    const addCartRes = await addCartReq.json();
                    window.tlAdvancedFreeGift.showIconPopUpMessage(addCartRes.description, 1)
                }
            }
        }else {
            if(availableToClaim.length){
                const manualText = window.tlAdvancedFreeGift.getRuleTranslation(availableToClaim[0]).gift_icon.manual
                window.tlAdvancedFreeGift.showIconPopUpMessage(manualText, availableToClaim.length);
            }else {
                // window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: none";
            }
        }
    
        window.tlAdvancedFreeGift.renderTempCart();
        if(hasRuleMetCondition){
            if (window.tlAdvancedFreeGift.displaySettings?.show_confetti_animation) {
                window.tlAdvancedFreeGift.showConfetti();
            }
            const isOpenGift = JSON.parse(localStorage.getItem('openGift'))
            if(isOpenGift){
              
            }
            else{
              localStorage.setItem('openGift',JSON.stringify(true))
              window.tlAdvancedFreeGift.openGiftModal(); 
            }
        }
        
        if(listRuleNeedToRemoveGift.length && !window.tlAdvancedFreeGift.itemsInTempCart.size){
            await window.tlAdvancedFreeGift.handleRemoveGift(listRuleNeedToRemoveGift);
            if(!window.TLCustomEventGiftsAdvanced){
                window.location.reload();
            } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"));
            }
        }
    }

    const overwriteRenderAdvancedFreeGift = () => {
      if (window.tlAdvancedFreeGift) {
        clearInterval(intervalId);
        window.tlAdvancedFreeGift.render= newRender;
        window.tlAdvancedFreeGift.reRender= newReRender;
      }
    }
    const intervalId = setInterval(overwriteRenderAdvancedFreeGift, 50);
    setTimeout(() => {
      clearInterval(intervalId);
    }, 3000);